function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanBeUsedDirectlyOnAnySurface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,70.6a4.11,4.11,0,0,1,3.88-1.87q34,.06,68,0c1.75,0,3.48.17,3.4,2.46-.07,2.1-1.7,2.23-3.35,2.23q-34.14,0-68.28,0A4.32,4.32,0,0,1,10,71.69V70.6Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,51c-.36.37-.71.76-1.1,1.1-1.62,1.46-3.71,1.45-5-.11A3.18,3.18,0,0,1,84,47.39a3.32,3.32,0,0,1,5,.18,15,15,0,0,1,1,1.26Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.51,26.52c.35.39.72.75,1,1.16,1.33,1.67,1.29,3.38-.26,4.79a3.09,3.09,0,0,1-4.59-.09c-1.53-1.49-1.47-3.18-.09-4.79a11.88,11.88,0,0,1,1.17-1.07Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,50.18c-2.09-.34-3.51-.55-4.93-.8a2.34,2.34,0,0,1,.59-4.64c3.86.45,7.71,1,11.57,1.56,1.12.15,1.55.66,1.37,1.81-.58,3.76-1.07,7.53-1.64,11.28a2.25,2.25,0,0,1-2.61,2.17c-1.63-.2-2.28-1.34-2.1-2.93.15-1.33.63-2.63.24-4.35-3.74,2.8-7.4,5.41-10.9,8.22-1.4,1.12-2.33,1.11-3.71,0-4.25-3.38-8.6-6.64-12.94-9.9-1.45-1.09-2.59-2.32-1.26-4s2.87-.74,4.24.31c3.3,2.54,6.66,5,9.91,7.61,1.31,1,2.27,1.31,3.71.1,2.54-2.14,5.29-4,8.47-6.43Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.54,42.6A3.44,3.44,0,0,1,44,46a3.33,3.33,0,0,1-3.31-3.31,3.46,3.46,0,0,1,3.35-3.56A3.54,3.54,0,0,1,47.54,42.6Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.25,32a3.56,3.56,0,0,1,3.55,3.39,3.52,3.52,0,0,1-3.47,3.47,3.37,3.37,0,0,1-3.39-3.26A3.48,3.48,0,0,1,29.25,32Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.51,61.39A3.45,3.45,0,0,1,71,58a3.4,3.4,0,0,1,3.54-3.33,3.26,3.26,0,0,1,3.33,3.26,3.36,3.36,0,0,1-3.38,3.48Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,55.9a3.4,3.4,0,0,1,3.37,3.51,3.28,3.28,0,0,1-3.33,3.27,3.39,3.39,0,1,1,0-6.78Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.34,40.14A3.41,3.41,0,0,1,73,43.65a3.32,3.32,0,0,1-3.46-3.15,3.41,3.41,0,0,1,3.23-3.64,3.45,3.45,0,0,1,3.61,3.28Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.22,51.72a3.36,3.36,0,0,1-3.4-3.44A3.31,3.31,0,0,1,17.35,45a3.21,3.21,0,0,1,3.26,3.29A3.27,3.27,0,0,1,17.22,51.72Z",
    style: {
      fill: "#E66C00"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanBeUsedDirectlyOnAnySurface);
export default __webpack_public_path__ + "static/media/can-be-used-directly-on-any-surface.0dbeca1140a983aad2971c58624ff9d4.svg";
export { ForwardRef as ReactComponent };